export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 7_05.09846529.jpg";